// extracted by mini-css-extract-plugin
export var container = "target-module--container--66b68";
export var info = "target-module--info--f9b76";
export var target = "target-module--target--5ea63";